(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const intervalMs = 5200;

  const setup = async () => {
    await customElements.whenDefined('slideshow-component');

    document.querySelectorAll('media-gallery slideshow-component').forEach((slideshow) => {
      if (slideshow.dataset.cloudoraAutoplayReady === 'true') return;
      slideshow.dataset.cloudoraAutoplayReady = 'true';

      const hasMultipleSlides = () => slideshow.querySelectorAll('slideshow-slide').length > 1;
      const updatePlayback = () => {
        if (!mobile.matches || reducedMotion.matches || document.hidden || !hasMultipleSlides()) {
          slideshow.pause();
          return;
        }
        slideshow.pause();
        slideshow.play(intervalMs);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) updatePlayback();
          else slideshow.pause();
        }, { threshold: 0.2 });
        observer.observe(slideshow);
      } else {
        updatePlayback();
      }

      mobile.addEventListener('change', updatePlayback);
      reducedMotion.addEventListener('change', updatePlayback);
      document.addEventListener('visibilitychange', updatePlayback);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
